import { Component, Input } from '@angular/core'
import { GuestCount } from '../../../../../../../graphql'

@Component({
    selector: 'app-listing-guest-details',
    templateUrl: './listing-guest-details.html'
})
export class ListingGuestDetailsComponent {
    @Input() guestCounts: GuestCount[]

    getIconForGuestType(guestType: string): string {
        switch (guestType.toLowerCase()) {
            case 'adults':
                return 'fa-user'
            case 'children':
                return 'fa-child'
            case 'infants':
                return 'fa-baby'
            default:
                return 'fa-user'
        }
    }

    getDisplayName(guestType: string, count: number): string {
        const type = guestType.toLowerCase()
        
        if (count === 1) {
            switch (type) {
                case 'adults':
                    return 'adult'
                case 'children':
                    return 'child'
                case 'infants':
                    return 'infant'
                default:
                    return 'guest'
            }
        } else {
            switch (type) {
                case 'adults':
                    return 'adults'
                case 'children':
                    return 'children'
                case 'infants':
                    return 'infants'
                default:
                    return 'guests'
            }
        }
    }
}